<template>
    <app-layout>
         <template #header>
             <div class="md:grid md:grid-cols-3 md:gap-6">
                <h2 class="md:col-span-2 font-semibold text-xl text-gray-800 leading-tight">
                    Users
                </h2>
                
                <div class="md:col-span-1 text-right">
                    <inertia-link href="/backoffice/users/create" class="items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150">
                       New User
                    </inertia-link>
                </div>
            </div>
        </template>

        <div class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
            <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">
                <table class="min-w-full leading-normal">
                    <thead>
                        <tr>
                            <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Id</th>
                            <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Name</th>
                            <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Email</th>
                            <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Role</th>
                            <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"></th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in users.data" :key="user.id">
                            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <p class="text-gray-900 whitespace-no-wrap"> {{ user.id }}</p>     
                            </td>

                             <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <p class="text-gray-900 whitespace-no-wrap"> {{ user.name }}</p>     
                            </td>
                             
                            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <p class="text-gray-900 whitespace-no-wrap"> {{ user.email }}</p>     
                            </td>
                            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <p class="text-gray-900 whitespace-no-wrap">{{user.role.name}}</p> 
                                 
                            </td>

                              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <inertia-link :href="'/backoffice/users/view/'+user.id" class=" px-3 border border-gray-300 bg-green-400 bg-opacity-50 rounded-md text-gray-600">Edit User</inertia-link>    
                            </td>
                            <!--
                            <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                 <button class="px-3 border border-gray-300 bg-red-400 bg-opacity-50 rounded-md text-gray-600" tabindex="-1" type="button" @click="destroy">Delete</button>
                            </td> -->
                            
                        </tr>
                    </tbody>
                </table>
            </div>
             <div class="card-footer">
                <pagination :links="users.links" />
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import ManagerLayout from './../../../Layouts/ManagerLayout'
import Pagination from './../../../Components/Pagination'
import throttle from 'lodash/throttle'
import Moment from 'moment'


export default {
     metaInfo() {
        return {
            title: 'Lista Korisnika' 
        }
    },
    components: {
        Pagination,
        AppLayout,
        ManagerLayout
    },

    // computed:{
    //     filteredOrganizations:function(){
    //         return this.organizations.filter((organization)=> {
    //             return organization.name.match(this.search)
    //         });
    //     }
    // },
    props: {
        users: Object
    },
    data(){
        return{
            form:{
                // search: this.filters.search,
                // trashed: this.filters.trashed,
            }
        }
    },
    watch: {
        form: {
        handler: throttle(function() {
            let query = pickBy(this.form)
            this.$inertia.replace(this.route('manager.users', Object.keys(query).length ? query : { remember: 'forget' }))
        }, 150),
        deep: true,
        },
    },
    methods: {
         getResults(page = 1){
            var self = this;
            axios.get('/manager/users/get?page=' + page)
            .then(response => {
                self.users = response.data;
            });
         },

         

         

        

    }
}
</script>